/** Enter compact only after scrolling past the full logo band (one wheel notch from top stays expanded) */
export const BROWSE_CHROME_COMPACT_ON_PX = 132;
/** Leave compact only when scrolled back above this (px) */
export const BROWSE_CHROME_COMPACT_OFF_PX = 12;
/** Keep compact while within this distance of the document bottom */
export const BROWSE_CHROME_NEAR_BOTTOM_PX = 140;
/** Ignore compact toggles for this long after a change (ms) — stops wheel threshold flicker */
export const BROWSE_CHROME_COMPACT_COOLDOWN_MS = 320;

/** Desktop-only — mobile keeps stable sticky chrome (compact causes layout jumps on touch scroll) */
export const BROWSE_CHROME_COMPACT_MIN_WIDTH_PX = 769;

export function isBrowseChromeCompactAllowed(viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1024) {
    return viewportWidth >= BROWSE_CHROME_COMPACT_MIN_WIDTH_PX;
}

/**
 * @param {boolean} compact — current compact state
 * @param {number} scrollY
 * @param {number} maxScroll — document scroll range (scrollHeight - innerHeight)
 * @returns {boolean}
 */
export function resolveBrowseChromeCompact(compact, scrollY, maxScroll) {
    const y = Math.max(0, scrollY);

    /* True top always expands — never keep compact at y=0 (incl. short pages where nearBottom would block) */
    if (y <= BROWSE_CHROME_COMPACT_OFF_PX) {
        return false;
    }

    const nearBottom =
        maxScroll > BROWSE_CHROME_COMPACT_ON_PX &&
        y >= maxScroll - BROWSE_CHROME_NEAR_BOTTOM_PX;

    if (nearBottom && y > BROWSE_CHROME_COMPACT_ON_PX) {
        return true;
    }

    if (y > BROWSE_CHROME_COMPACT_ON_PX) {
        return true;
    }

    /* Dead band between OFF (12) and ON (72): hold current state */
    return compact;
}
